import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ALLOWED = ['teacher', 'admin', 'superadmin'];

/**
 * Teacher UI is for role=teacher; admin/superadmin may access for testing/oversight.
 */
export default function TeacherRoleRoute({ children }) {
  const { user } = useAuth();
  if (!user || !ALLOWED.includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
